import React, { useEffect, useState } from "react";
import Logo from "../img/xapiens-logo.png";
import { Button, Image, Nav, Navbar } from "react-bootstrap";
import { BsBell } from "react-icons/bs";
import { BiLogOut } from "react-icons/bi";
import { Link, NavLink, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../redux/actions/loginAction";
import { getStatusSPV, getTaskListLength, reqTaskListSVP } from "../redux/actions/spvAction";

import { NotificationContainer } from "react-notifications";

// import { createNotificationSupervisor } from "./Notification.component";
import { useQuery } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";
import {
  GET_PROJECT_SUPERVISOR,
  GET_TASK_SUPERVISOR,
} from "../graphql/queries";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

const NavigationBar = ({
  logout,
  notPlanner,
  getTaskListTotalLength,
  getTaskListLength,
  reqTaskListSVP,
  taskList
}) => {
  const [isNotif, setNotif] = useState(false);

  const [currData, setCurrData] = useState("")

  useEffect(() => {
    reqTaskListSVP()
    setCurrData(taskList.data.length)

  }, [])
  // const notify = () => toast("Planner has submitted a new task list. Check your recent task list");

  console.log(currData)

  console.log(taskList.data.length);

  const notify = () =>
    toast(
      "Planner has submitted a new task list. Check your recent task list",
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        // progress: undefined,
      }
    );

    const styleActive = {
      color: "#007bff",
      paddingBottom: "0.5rem",
      borderBottom: "2px solid #007bff",
    };

    const [expanded, setExpanded] = useState(false);

  // useEffect(() => {
  //   getTaskListTotalLength > getTaskListTotalLength && setNotif(!isNotif);
  //   isNotif && notify()
  // }, [notify])

  const history = useHistory();
  const { data: currDataPoll, loading, error } = useQuery(GET_TASK_SUPERVISOR, {
    pollInterval: 1000,
  }); // TODOS: GET ALL PROJECT SUPERVISOR STATUS

  if (loading) return <LinearProgress />;

  //  if (currDataPoll.findAllTaskSupervisor.length > taskList.data.length) setNotif(!isNotif);

  // getTaskListLength(data.findAllTaskSupervisor.length);

  // isNotif && notify();

  // console.log(data.findAllTaskSupervisor.length)
  // useEffect(() => {
  //   getTaskListLength(data.findAllTaskSupervisor.length);
  //   console.log(data.findAllTaskSupervisor.length !== getTaskListTotalLength)
  // data.findAllTaskSupervisor.length !== getTaskListTotalLength
  //   ? setNotif(true)
  //   : setNotif(false);
  //   console.log(getTaskListTotalLength);
  // }, [])
  // useEffect(() => {
  //   // const getAllTaskLength = () =>
  //   //   data.findAllProjectSupervisor.map(({ status }) => {
  //   //     let newArr = [...updateStatusProject, status];
  //   //     return getStatusSPV(newArr);
  //   //   }); // TODOS: GET ALL STATUS PROJECT SUPERVISOR TO A NEW ARRAY
  //  data.findAllTaskSupervisor.map(({task}) => {
  //     newArr.push(task)
  //   })
  // }, []);

  return (
    <div className="navbar-section">
      <ToastContainer />
      <Navbar bg="light" expand="lg" sticky="top" expanded={expanded}>
        <Nav.Link as={Link} to="/dashboard/supervisor/">
          <Image src={Logo} fluid />
        </Nav.Link>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto" />
          <NavLink
            className="mx-3 d-flex flex-column"
            activeStyle={styleActive}
            style={{ color: "gray" }}
            to="/dashboard/supervisor/main-dashboard"
            onClick={() => setExpanded(false)}
            exact
          >
            Main Dashboard
          </NavLink>
          <NavLink
            className="mx-3 d-flex flex-column"
            activeStyle={styleActive}
            style={{ color: "gray" }}
            to="/dashboard/supervisor/user-panel"
            onClick={() => setExpanded(false)}
            exact
          >
            User Panel
          </NavLink>
          <NavLink
            className="mx-3 d-flex flex-column"
            activeStyle={styleActive}
            style={{ color: "gray" }}
            to="/dashboard/supervisor/project-list"
            onClick={() => setExpanded(false)}
          >
            Project From Planner
          </NavLink>
          <NavLink
            className="mx-3 d-flex flex-column"
            activeStyle={styleActive}
            style={{ color: "gray" }}
            to="/dashboard/supervisor/task-list"
            onClick={() => setExpanded(false)}
          >
            Project From Worker
          </NavLink>
          <div className="navbar-button">
            <Button
              className="icon-button mr-sm-2 rounded-circle"
              variant="outline-primary"
              onClick={isNotif && notify}
            >
              <BsBell />
            </Button>
            <Button
              className="icon-button mr-sm-2 rounded-circle"
              variant="outline-danger"
              onClick={() => {
                logout();
                history.push("/");
                window.location.reload();
              }}
            >
              <BiLogOut />
            </Button>
          </div>
        </Navbar.Collapse>
      </Navbar>
      <NotificationContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    updateStatusProject: state.spv.updateStatusProject,
    getTaskListTotalLength: state.spv.getTaskListLength,
    taskList: state.spv.taskList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // getStatusSPV: (inputStatusSPV) => dispatch(getStatusSPV(inputStatusSPV)),
    getTaskListLength: (taskListData) =>
      dispatch(getTaskListLength(taskListData)),
      reqTaskListSVP: () =>
      dispatch(reqTaskListSVP()),
    logout: () => dispatch(logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
